module.exports = __webpack_public_path__ + "static/media/whips.7495487a.png";